const quotationUrlBase =
    (window._env_ ? window._env_.REACT_APP_COTIZADOR_API_URL : false) ||
    process.env.REACT_APP_COTIZADOR_API_URL;
const quotationUrlApi = `${quotationUrlBase}`;

export default {
    quotationUrlBase,
    quotationUrlApi
};
